/*global google*/
import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from "axios";

import AdminHeaderNew from '../Common/AdminHeader';
import AdminSideBarNew from '../Common/AdminSideBar';
import AdminFooterNew from '../Common/AdminFooter';
import '../../../assets/styles/Style.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import kmLogo from "../../../assets/images/km_logo.png";

function AssignTargetOS() {

    const [latestSurveyCount, setLatestSurveyCount] = useState([]);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [statesData, setStatesData] = useState([]);
    const [assignTargetListing, setAssignTargetListing] = useState([]);
    const [targetPlaceholder, setTargetPlaceholder] = useState("000000");
    //const [revisedTargetPlaceholder, setRevisedTargetPlaceholder] = useState("000000");
    const [assignDistrictTarget, setAssignDistrictTarget] = useState("");
    const [assignSubDistrictTarget, setAssignSubDistrictTarget] = useState("");
    const [assignTarget, setAssignTarget] = useState("");
    const [missionTargetSummary, setMissionTargetSummary] = useState([]);
    const [summaryString, setSummaryString] = useState('');
    const [uom, setUom] = useState("");
    //const [revisedTarget, setRevisedTarget] = useState("");
    const [stateValue, setStateValue] = useState('');
    const [subDistrictValues, setSubDistrictValues] = useState('');
    const [revisedByState, setRevisedByState] = useState('');
    const [revisedTargetByState, setRevisedTargetByState] = useState('');
    const [villageCode, setVillageCode] = useState('');
    const [finYear, setFinYear] = useState(() => {
        return getCurrentFinancialYear();
    });
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const currentSchemeName = sessionStorage.getItem("currentSchemeName");
    const currentStateName = sessionStorage.getItem("currentStateName");
    const currentDistrictName = sessionStorage.getItem("currentDistrictName");
    const [districtValue, setDistrictValue] = useState('');
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showTargetInput, setShowTargetInput] = useState(false);
    const userType = sessionStorage.getItem("userTypeCodeModel");
    const [expandedRowData, setExpandedRowData] = useState([]);
    const [editRow, setEditRow] = useState(null);
    const [showModals, setShowModals] = useState(false);

    const [ddlSubTypeList, setDDlSubTypeList] = useState([]);
    const [txtlType, setTxtlType] = useState("");
    const [selectedValue, setSelectedValue] = useState('');

    //const [otherText, setOtherText] = useState('');
    const [rows, setRows] = useState([]);
    const [rowValues, setRowValues] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [isStateRevised, setIsStateRevised] = useState(false);
    const [isYesButtonDisabled, setIsYesButtonDisabled] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [assignTargetReports, setAssignTargetReports] = useState([]);
    const [assignTargetReportsSurvey, setAssignTargetReportsSurvey] = useState([]);

    const [selectedTypeData, setSelectedTypeData] = useState({
        revisedTargetByState: '',
        centralMission: '',
        districtName: '',
        districtMission: ''
    });
    const [groupedSchemeData, setGroupedSchemeData] = useState([]);
    // const [cropGroup, setCropGroup] = useState([]);
    //const [cropName, setCropName] = useState([]);
    //const [selectedCropGroup, setSelectedCropGroup] = useState('');
    //const [selectedCropName, setSelectedCropName] = useState('');

    const [cropGroup, setCropGroup] = useState([]);
    const [cropName, setCropName] = useState([]);
    const [cropSeason, setCropSeason] = useState([]);
    const [selectedCropGroup, setSelectedCropGroup] = useState("NA");
    const [selectedCropName, setSelectedCropName] = useState("NA")
    const [selectedCropSeason, setSelectedCropSeason] = useState("NA")
    const [selectedCropGroupForModal, setSelectedCropGroupForModal] = useState("NA");
    const [selectedCropNameForModal, setSelectedCropNameForModal] = useState("NA");
    const [selectedCropSeasonForModal, setSelectedCropSeasonForModal] = useState("NA");
    const [cropNameForModal, setCropNameForModal] = useState([]);
    const [cropSeasonForModal, setCropSeasonForModal] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    console.log('assignTargetListing----: ', assignTargetListing);
    //const filteredListing = useMemo(() => {
    //    return assignTargetListing.filter((survey) => {
    //        return (userType === "3" && survey.subDistrictName !== null) ||
    //            (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
    //    });
    //}, [assignTargetListing, userType]);
    const [formData, setFormData] = useState({
        schemeName: "",
        stateName: "",
        districtName: "",
        missionTarget: "",
        finYear: "",
        cropGroupCode: "",
        cropGroupName: "",
        cropNameCode: "",
        cropCategoryCode: "",
        Season: ""
    });
    const filteredListing = useMemo(() => {
        return assignTargetListing.filter((survey) => {
            if (userType === "3") {
                // keep only if subDistrictName exists
                return !!survey.districtName?.trim();
            }
            if (userType === "2") {
                // keep only if districtName exists
                return !!survey.districtName?.trim();
            }
            // for other userTypes, keep everything
            return true;
        });
    }, [assignTargetListing, userType]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const paginatedListing = useMemo(() => {
        return filteredListing.slice(indexOfFirstRecord, indexOfLastRecord);
    }, [filteredListing, indexOfFirstRecord, indexOfLastRecord]);

    const totalPages = Math.ceil(filteredListing.length / recordsPerPage);
    const handleResetEditForm = () => {
        setStateValue('');
        setSelectedValue('');
        setAssignTarget('')
        setUom('');
        setSelectedCropGroupForModal("NA");
        setSelectedCropNameForModal("NA");
        setSelectedCropSeasonForModal("NA");
        setCropNameForModal([]);
        setShowModals(false)
    };
    // Reset to first page when the filtered list changes
    useEffect(() => {
        setCurrentPage(1);
    }, [filteredListing]);

    // console.log('selectedValue:', selectedValue);
    let propType = null;
    if (sessionStorage.getItem("userTypeCodeModel") === "2") {
        propType = "subTypeCode";
    } else {
        propType = "schemeSubTypeName";
    }



    const selectedTypeObj = missionTargetSummary.find(
        item => String(item[propType]) === String(selectedValue)
    );
    console.log("selectedTypeObj", selectedTypeObj);
    // console.log('selectedTypeObj', selectedTypeObj);
    // console.log('missionTargetSummary at top', missionTargetSummary);
    function getCurrentFinancialYear() {
        const today = new Date();
        const year = today.getFullYear();
        if (today.getMonth() < 3) {
            return `${year - 1}-${year}`;
        } else {
            return `${year}-${year + 1}`;
        }
    }

    const handleRowClearVillage = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });

        // Clear village options
        setOptionVillage([]);

        // Reset the row values (Village and Assign Target)
        setRowValues(prev =>
            prev.map((row, i) => ({
                ...row,
                villageValue: "",
                targetValue: ""
            }))
        );
    };

    const handleFinYearChange = (e) => {
        const value = String(e.target.value || "");
        sessionStorage.setItem("finYear", value);
        setFinYear(value);
        assignTargetData(value);
    };

    const handleRowClearSubDistrict = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });

        // Reset the row values (Sub District and Assign Target)
        setRowValues(prev =>
            prev.map((row, i) => ({
                ...row,
                subDistrictValue: "",
                targetValue: ""
            }))
        );
    };

    const handleRowClear = () => {
        setSelectedValue('');
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });
        setInputValues(prev => ({
            ...prev,
            [0]: {
                ...prev[0],
                districtValue: "",
                assignDistrictTarget: ""
            }
        }));
    };

    useEffect(() => {
        surveysCountGroupWise();
        assignTargetData();
        //getDistrict();
        //handleSubDistrict();
        //handleVillage();
        CropGroup();
        CropSeason();
        fetchSubSchemeType();
        getStates(); // Load states on page load
        if (sessionStorage.getItem("userTypeCodeModel") === "2") {
            setStateValue(sessionStorage.getItem("currentStateName") || "");
        }
    }, []);

    // Update state value when states are loaded and editRow exists
    useEffect(() => {
        if (editRow && statesData.length > 0 && showModals && editRow.stateCode) {
            const stateCode = editRow.stateCode.toString();
            setStateValue(stateCode);
        }
    }, [statesData, editRow, showModals]);

    // Fetch crop names when crop group is selected in modal
    useEffect(() => {
        if (selectedCropGroupForModal && selectedCropGroupForModal !== "NA" && showModals) {
            const cropGroupCode = parseInt(selectedCropGroupForModal);
            if (cropGroupCode) {
                CropNameForModal(cropGroupCode);
            }
        } else if (showModals && (!selectedCropGroupForModal || selectedCropGroupForModal === "NA")) {
            setCropNameForModal([]);
        }
    }, [selectedCropGroupForModal, showModals]);

    useEffect(() => {
        const joinedTargets = missionTargetSummary
            .filter(item => item.schemeSubTypeName && item.centralMission !== undefined)
            .map(item => `${item.schemeSubTypeName} - ${item.centralMission}`)
            .join(', ');

        setSummaryString(joinedTargets);
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            setRowValues(
                missionTargetSummary.map(() => ({
                    subDistrictValue: '',
                    targetValue: ''
                }))
            );
        }
    }, [missionTargetSummary]);

    useEffect(() => {
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            const initialInputs = {};
            missionTargetSummary.forEach((item, idx) => {
                initialInputs[idx] = {
                    revisedTargetByState: item.revisedTargetByState || ''
                };
            });
            setInputValues(initialInputs);
        }
    }, [missionTargetSummary]);


    const [inputValues, setInputValues] = useState({});
    const handleChange = (idx, value) => {
        setInputValues(prev => ({
            ...prev,
            [idx]: {
                ...prev[idx],
                revisedTargetByState: value
            }
        }));
    };

    async function surveysCountGroupWise() {
        const roleCode = sessionStorage.getItem("userTypeCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel") || 0;
        const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel") || 0;

        const parm = {
            schemeCode,
            stateCode: roleCode >= 2 ? stateCode : 0,
            districtCode: roleCode >= 3 ? districtCode : 0,
            subDistrictCode: roleCode >= 4 ? subDistrictCode : 0,
            userLevel: roleCode
        };

        try {
            const { data } = await axios.post(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/SurveysCountGroupWise`,
                parm
            );
            setLatestSurveyCount(data.dataContent);
        } catch (error) {
            console.error("Error fetching  details:", error);
        }
    }

    const handleSubTypeSelect = (value) => {
        setSelectedValue(value);
    };

    //const handleCropGroupChange = (e) => {
    //    const value = parseInt(e.target.value) || 0;
    //    setSelectedCropGroup(value);
    //    CropName(value);
    //    //console.log('handleSelectCropGroup value: ', value);
    //   // console.log('selectedCropGroup: ', selectedCropGroup);

    //};

    const handleCropGroupChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        setSelectedCropGroup(value);
        setSelectedCropName("NA"); // reset Crop Name to Choose...
        setAssignTarget("");
        if (value) {
            CropName(value);             // fetch crop names for this group
        } else {
            setCropName([]);             // clear names if invalid
        }
    };

    //const handleCropName = (e) => {
    //    const value = parseInt(e.target.value) || 0;
    //    setSelectedCropName(value);

    //};
    const handleCropName = (e) => {
        const value = parseInt(e.target.value) || 0;
        setSelectedCropName(value);
        setAssignTarget("");
    };

    const handleCropSeason = (e) => {
        const value = parseInt(e.target.value) || 0;
        setSelectedCropSeason(value);
        setAssignTarget("");
    };



    const handleAdd = (e) => {
        e.preventDefault();
        if (rows.length < 2) {
            setRows(prevRows => {
                // Add the new row with a 'target' property
                return [...prevRows, { id: Date.now(), selected: '', custom: '', target: '' }];
            });
        } else {
            alert('Maximum 2 type allowed');
        }
    };

    const handleRemove = (id) => {
        setRows(rows.filter(row => row.id !== id));
    };

    const handleSelectChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, selected: value.toString(), custom: '' } : row
        ));
    };

    //const handleCustomChange = (id, value) => {
    //    setRows(rows.map(row =>
    //        row.id === id ? { ...row, custom: value } : row
    //    ));
    //};

    //const handleTargetChange = (id, value) => {
    //    setRows(rows.map(row =>
    //        row.id === id ? { ...row, target: value } : row
    //    ));
    //};

    const getAvailableOptions = (currentId) => {
        // Gather all selected values from rows except the current row
        const rowSelectedValues = rows
            .filter(row => row.id !== currentId)
            .map(row => row.selected)
            .filter(val => val && val !== 'Other');

        let allSelected = [...rowSelectedValues];
        if (currentId === 'main') {
            // For main select, include all row selections (already done)
        } else {
            // For row selects, include main select's value if not 'Other' or 'NA'
            if (selectedValue && selectedValue !== 'Other' && selectedValue !== 'NA') {
                allSelected.push(selectedValue);
            }
        }
        return ddlSubTypeList.filter(option => !allSelected.includes(String(option.id)));
    };


    async function fetchSubSchemeType() {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const url = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/MissionTarget/MissionTarget/GetSchemaSubTypeList/${schemeCode}`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                setDDlSubTypeList(data.dataContent);

            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    }
    const handleUpdate = async () => {
        try {
            // Get crop group code and name from selectedCropGroupForModal
            let cropGroupCodeValue = "";
            let cropGroupNameValue = "";

            if (selectedCropGroupForModal && selectedCropGroupForModal !== "NA") {
                cropGroupCodeValue = selectedCropGroupForModal;
                // Find the crop group name from cropGroup array
                const selectedCropGroupObj = cropGroup.find(
                    (opt) => opt.cropGroupCode && opt.cropGroupCode.toString() === selectedCropGroupForModal.toString()
                );
                if (selectedCropGroupObj) {
                    cropGroupNameValue = selectedCropGroupObj.cropGroupName || "";
                }
            }

            // Get season code from formData or selectedCropSeasonForModal
            let seasonCodeValue = "";
            if (formData.cropSeasonCode) {
                seasonCodeValue = formData.cropSeasonCode;
            } else if (selectedCropSeasonForModal && selectedCropSeasonForModal !== "NA") {
                seasonCodeValue = selectedCropSeasonForModal;
            } else if (editRow && (editRow.seasonCode || editRow.seasons)) {
                seasonCodeValue = editRow.seasonCode || editRow.seasons;
            }

            const payload = [{

                "id": editRow.id,
                "finYear": finYear,
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"),
                "stateCode": stateValue !== "NA" ? Number(stateValue) : null,
                "districtCode": null,
                "subDistrictCode": null,
                "villageCode": null,
                "missionTarget": Number(formData.missionTarget),
                "remarks": "Updated target",
                "createdBy": sessionStorage.getItem("userCodeModel"),
                "revisedTargetByState": null,
                "isRevisedByState": "N",
                "subTypeCode": selectedValue !== "NA" ? Number(selectedValue) : null,
                "uomType": uom,
                "cropGroupCode": cropGroupCodeValue,
                "cropGroupName": cropGroupNameValue,
                "cropNameCode": selectedCropNameForModal !== "NA" ? selectedCropNameForModal : (editRow.cropNameCode || null),
                "seasons": seasonCodeValue || null,
                "seasonCode": seasonCodeValue || null
            }];
            console.log("Update payload:", payload);
            const response = await axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/UpdateMissionTarget`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("Update response:", response.data);

            setShowModals(false);

            // Get crop name from selectedCropNameForModal
            let cropNameValue = "";
            if (selectedCropNameForModal && selectedCropNameForModal !== "NA") {
                // Find crop name from cropNameForModal or cropName array
                const matchedCropName = cropNameForModal.find(
                    (cn) => cn.cropNameCode && cn.cropNameCode.toString() === selectedCropNameForModal.toString()
                ) || cropName.find(
                    (cn) => cn.cropNameCode && cn.cropNameCode.toString() === selectedCropNameForModal.toString()
                );
                if (matchedCropName) {
                    cropNameValue = matchedCropName.cropName || "";
                }
            }

            // Update local state immediately for better UX
            if (editRow) {
                setAssignTargetListing(prevListing =>
                    prevListing.map(item => {
                        // Match by id if available, otherwise match by stateCode, cropGroupCode, cropNameCode, and schemeSubTypeName
                        const isMatch = editRow.id
                            ? (item.id === editRow.id)
                            : (item.stateCode === editRow.stateCode &&
                                item.cropGroupCode === editRow.cropGroupCode &&
                                item.cropNameCode === editRow.cropNameCode &&
                                item.schemeSubTypeName === editRow.schemeSubTypeName);

                        if (isMatch) {
                            return {
                                ...item,
                                cropGroupCode: cropGroupCodeValue || item.cropGroupCode,
                                cropGroupName: cropGroupNameValue || item.cropGroupName,
                                cropNameCode: selectedCropNameForModal !== "NA" ? selectedCropNameForModal : item.cropNameCode,
                                cropName: cropNameValue || item.cropName,
                                missionTarget: Number(formData.missionTarget) || item.missionTarget,
                                centralMission: Number(formData.missionTarget) || item.centralMission,
                                seasons: formData.cropSeasonCode || (selectedCropSeasonForModal !== "NA" ? selectedCropSeasonForModal : "") || item.seasons,
                                seasonName: formData.cropSeasonCode || (selectedCropSeasonForModal !== "NA" ? selectedCropSeasonForModal : "") || item.seasonName
                            };
                        }
                        return item;
                    })
                );
            }

            // Show success message
            if (response.data && response.data.success) {
                alert("Target updated successfully!");
                // Refresh data from server after a delay to ensure backend has processed the update
                // This ensures updated data is visible after page refresh
                setTimeout(async () => {
                    try {
                        await assignTargetData();
                    } catch (error) {
                        console.error("Error refreshing data after update:", error);
                        // If refresh fails, at least we have the local state update
                    }
                }, 1000); // Increased delay to 1 second to ensure backend processing
            } else {
                // Refresh even if response format is different
                await assignTargetData();
            }


        } catch (error) {
            console.error("Update failed", error);
            alert("Failed to update target. Please try again.");
        }


    };
    const CropGroup = async () => {
        const payload = {
            "cropGroupCode": 0,
            "cropCode": 0,
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
        };



        try {
            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Management/CommSeedRegistry/getCropGroupList`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const CropGroupResult = await response.json();
            //console.log('CropGroupResult:', CropGroupResult.dataContent);
            setCropGroup(CropGroupResult.dataContent);

        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };

    const CropName = async (cropCode) => {
        //console.log('cropCode inside CropName fn ', cropCode);
        const payload = {
            "cropGroupCode": cropCode,
            // "cropCode": cropCode,
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
        };

        //console.log('payload CropName', payload)

        try {
            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Management/CommSeedRegistry/getCropNameList`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const CropNameResult = await response.json();
            //console.log('CropNameResult:', CropNameResult.dataContent);
            setCropName(CropNameResult.dataContent);

        } catch (error) {
            // console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };
    const CropSeason = async () => {
        try {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/seasons`
            );
            //  const CropNameResult = await response.json();
            setCropSeason(result.data.dataContent);

        } catch (error) {
            // console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };

    const handleEdit = (row) => {
        setEditRow(row);
        setUom(row.uomType || "");

        // Ensure states are loaded before setting state value
        if (statesData.length === 0) {
            getStates();
        }

        setStateValue(row.stateCode ? row.stateCode.toString() : "NA");

        // Initialize formData from row (use callback to avoid stale state)
        setFormData(prev => ({
            ...prev,
            schemeName: row.schemeName || "",
            stateName: row.stateName || "",
            districtName: row.districtName || "",
            missionTarget: row.centralMission ?? "",
            finYear: row.finYear || "",
            cropSeasonCode: row.seasonCode || row.seasonName || ""
        }));

        // Find matched option in full ddlSubTypeList (not filtered) for more accurate matching
        const matchedOptionInFullList = ddlSubTypeList && ddlSubTypeList.length > 0
            ? ddlSubTypeList.find((opt) => opt.schemeSubTypeName === row.schemeSubTypeName)
            : null;

        const matchedOption = getAvailableOptions('main').find(
            (opt) => opt.schemeSubTypeName === row.schemeSubTypeName
        );

        setSelectedValue(matchedOption ? matchedOption.id.toString() : "NA");

        // Auto-fill Crop Group based on row data
        // First try to match using cropGroup state (which uses cropGroupCode)
        let selectedCropGroupCode = "NA";
        if (row.cropGroupName && cropGroup && cropGroup.length > 0) {
            const matchedCropGroup = cropGroup.find(
                (opt) => opt.cropGroupName && opt.cropGroupName.trim() === row.cropGroupName.trim()
            );

            if (matchedCropGroup) {
                selectedCropGroupCode = matchedCropGroup.cropGroupCode.toString();
                setSelectedCropGroupForModal(selectedCropGroupCode);
            } else {
                // Fallback: try case-insensitive match
                const matchedCropGroupCaseInsensitive = cropGroup.find(
                    (opt) => opt.cropGroupName && opt.cropGroupName.trim().toLowerCase() === row.cropGroupName.trim().toLowerCase()
                );
                selectedCropGroupCode = matchedCropGroupCaseInsensitive ? matchedCropGroupCaseInsensitive.cropGroupCode.toString() : "NA";
                setSelectedCropGroupForModal(selectedCropGroupCode);
            }
        } else if (row.cropGroupName && ddlSubTypeList && ddlSubTypeList.length > 0) {
            // Fallback: search in full ddlSubTypeList if cropGroup is not available
            let matchedCropGroupOption = null;

            // First try exact match on cropGroupName with cropName and cropSeason
            if (row.cropName && row.seasonName) {
                matchedCropGroupOption = ddlSubTypeList.find(
                    (opt) =>
                        opt.cropGroupName && opt.cropGroupName.trim() === row.cropGroupName.trim() &&
                        opt.cropName && opt.cropName.trim() === row.cropName.trim() &&
                        opt.cropSeason && opt.cropSeason.trim() === row.seasonName.trim()
                );
            }

            // If not found, try match on cropGroupName only
            if (!matchedCropGroupOption) {
                matchedCropGroupOption = ddlSubTypeList.find(
                    (opt) => opt.cropGroupName && opt.cropGroupName.trim() === row.cropGroupName.trim()
                );
            }

            // If still not found, try case-insensitive match
            if (!matchedCropGroupOption) {
                matchedCropGroupOption = ddlSubTypeList.find(
                    (opt) => opt.cropGroupName && opt.cropGroupName.trim().toLowerCase() === row.cropGroupName.trim().toLowerCase()
                );
            }

            selectedCropGroupCode = matchedCropGroupOption ? matchedCropGroupOption.id.toString() : "NA";
            setSelectedCropGroupForModal(selectedCropGroupCode);
        } else {
            setSelectedCropGroupForModal("NA");
        }

        // Fetch crop names for the selected crop group and then auto-fill crop name
        if (selectedCropGroupCode && selectedCropGroupCode !== "NA") {
            const cropGroupCode = parseInt(selectedCropGroupCode);
            if (cropGroupCode) {
                CropNameForModal(cropGroupCode).then((fetchedCropNames) => {
                    // After fetching crop names, try to match and set crop name
                    if (row.cropName && fetchedCropNames && fetchedCropNames.length > 0) {
                        const matchedCropName = fetchedCropNames.find(
                            (opt) => opt.cropName && opt.cropName.trim() === row.cropName.trim()
                        ) || fetchedCropNames.find(
                            (opt) => opt.cropName && opt.cropName.trim().toLowerCase() === row.cropName.trim().toLowerCase()
                        );
                        if (matchedCropName) {
                            setSelectedCropNameForModal(matchedCropName.cropNameCode.toString());
                        } else {
                            // Try to find in main cropName state as fallback
                            const matchedInMain = cropName.find(
                                (opt) => opt.cropName && opt.cropName.trim() === row.cropName.trim()
                            );
                            if (matchedInMain) {
                                setSelectedCropNameForModal(matchedInMain.cropNameCode.toString());
                            }
                        }
                    }
                });
            }
        }

        // Auto-fill Crop Season
        if (row.seasonName && cropSeason && cropSeason.length > 0) {
            const matchedSeason = cropSeason.find(
                (opt) => opt.seasonName && opt.seasonName.trim() === row.seasonName.trim()
            ) || cropSeason.find(
                (opt) => opt.seasonName && opt.seasonName.trim().toLowerCase() === row.seasonName.trim().toLowerCase()
            );
            if (matchedSeason) {
                const seasonCodeValue = matchedSeason.seasonCode ? matchedSeason.seasonCode.toString() : matchedSeason.id ? matchedSeason.id.toString() : "NA";
                setSelectedCropSeasonForModal(seasonCodeValue);
                setFormData(prev => ({ ...prev, cropSeasonCode: seasonCodeValue !== "NA" ? seasonCodeValue : "" }));
            }
        }

        setShowModals(true);
    };

    const handleCropGroupChangeInModal = async (e) => {
        const selectedId = e.target.value;
        setSelectedCropGroupForModal(selectedId);
        // Reset crop name and season when crop group changes
        setSelectedCropNameForModal("NA");
        setSelectedCropSeasonForModal("NA");
        setCropNameForModal([]);

        // Fetch crop names for the selected crop group
        if (selectedId && selectedId !== "NA") {
            const cropGroupCode = parseInt(selectedId);
            if (cropGroupCode) {
                await CropNameForModal(cropGroupCode);
            }
        } else {
            setCropNameForModal([]);
        }
    };

    const handleCropNameChangeInModal = async (e) => {
        const selectedId = e.target.value;
        setSelectedCropNameForModal(selectedId);
        // Reset crop season when crop name changes
        setSelectedCropSeasonForModal("NA");

        // Crop season is fetched globally, so we can use the existing cropSeason state
        // or fetch based on crop name if needed
    };

    const handleCropSeasonChangeInModal = (e) => {
        const selectedId = e.target.value;
        setSelectedCropSeasonForModal(selectedId);
        setFormData({ ...formData, cropSeasonCode: selectedId !== "NA" ? selectedId : "" });
    };

    // Function to fetch crop names for modal based on crop group
    const CropNameForModal = async (cropCode) => {
        const payload = {
            "cropGroupCode": cropCode,
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
        };

        try {
            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/Management/CommSeedRegistry/getCropNameList`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const CropNameResult = await response.json();
            const cropNames = CropNameResult.dataContent || [];
            setCropNameForModal(cropNames);
            return cropNames; // Return for use in promise chain

        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
            setCropNameForModal([]);
            return [];
        }
    };

    // Helper function to get crop name for the modal
    const getCropNameForModal = () => {
        // If editing and row has cropName, use it (priority)
        if (editRow?.cropName) return editRow.cropName;
        // Otherwise, find from selected crop group option
        if (selectedCropGroupForModal && selectedCropGroupForModal !== "NA") {
            // First try to find in ddlSubTypeList by id (if using ddlSubTypeList)
            let selectedOption = ddlSubTypeList.find(
                (opt) => opt.id && opt.id.toString() === selectedCropGroupForModal
            );

            // If not found and using cropGroup state, find matching option in ddlSubTypeList by cropGroupCode
            if (!selectedOption && cropGroup && cropGroup.length > 0) {
                const selectedCropGroup = cropGroup.find(
                    (opt) => opt.cropGroupCode && opt.cropGroupCode.toString() === selectedCropGroupForModal
                );
                if (selectedCropGroup && selectedCropGroup.cropGroupName) {
                    // Find in ddlSubTypeList by cropGroupName
                    selectedOption = ddlSubTypeList.find(
                        (opt) => opt.cropGroupName && opt.cropGroupName.trim() === selectedCropGroup.cropGroupName.trim()
                    );
                }
            }

            if (selectedOption?.cropName) return selectedOption.cropName;
        }
        // Fallback to selectedTypeObj
        return selectedTypeObj?.cropName || '';
    };

    // Helper function to get crop season for the modal
    const getCropSeasonForModal = () => {
        // If editing and row has seasonName, use it (priority)
        if (editRow?.seasonName) return editRow.seasonName;
        // Otherwise, find from selected crop group option
        if (selectedCropGroupForModal && selectedCropGroupForModal !== "NA") {
            // First try to find in ddlSubTypeList by id (if using ddlSubTypeList)
            let selectedOption = ddlSubTypeList.find(
                (opt) => opt.id && opt.id.toString() === selectedCropGroupForModal
            );

            // If not found and using cropGroup state, find matching option in ddlSubTypeList by cropGroupCode
            if (!selectedOption && cropGroup && cropGroup.length > 0) {
                const selectedCropGroup = cropGroup.find(
                    (opt) => opt.cropGroupCode && opt.cropGroupCode.toString() === selectedCropGroupForModal
                );
                if (selectedCropGroup && selectedCropGroup.cropGroupName) {
                    // Find in ddlSubTypeList by cropGroupName
                    selectedOption = ddlSubTypeList.find(
                        (opt) => opt.cropGroupName && opt.cropGroupName.trim() === selectedCropGroup.cropGroupName.trim()
                    );
                }
            }

            if (selectedOption?.cropSeason) return selectedOption.cropSeason;
        }
        // Fallback to selectedTypeObj
        return selectedTypeObj?.cropSeason || '';
    };


    const assignTargetData = async (yearOverride) => {
        setIsTableLoading(true);
        const activeYear = yearOverride || finYear;
        const payload = {
            finYear: activeYear,
            flag: 0,
            orgTypeCode: sessionStorage.getItem("userTypeCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userTypeCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        const payload_Report = {
            finYear: activeYear,
            flag: 0,
            userLevel: sessionStorage.getItem("userTypeCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userTypeCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userTypeCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };
        //console.log('assignTargetData 111 payload for second api', payload);
        //console.log('StateCode: ', sessionStorage.getItem("stateNameModel"));
        try {
            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/getMissionTargetSummary`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            const response_Report = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SurveyCountGroupWise/SurveysCountGroupWiseNew`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload_Report),
                }
            );

            const result_Report = await response_Report.json();
            console.log('payload_Report: ', payload_Report);
            console.log('payload: ', payload);
            setAssignTargetReports(result_Report.dataContent);
            setAssignTargetReportsSurvey(result_Report.dataContent);

            console.log('setAssignTargetReportsSurveysetAssignTargetReportsSurvey ', result_Report.dataContent);
            // console.log('result.dataContent ', result.dataContent);
            // console.log('cropGroup array for enrichment:', cropGroup);
            // console.log('cropName array for enrichment:', cropName);

            // Check if result.dataContent exists and is an array before processing
            if (result.dataContent && Array.isArray(result.dataContent) && result.dataContent.length > 0) {
                // Enrich the data by mapping cropGroupCode to cropGroupName and cropNameCode to cropName
                const enrichedData = result.dataContent.map(item => {
                    const enrichedItem = { ...item };

                    // Map cropGroupCode or cropCategoryCode to cropGroupName if not already present or empty
                    if ((!enrichedItem.cropGroupName || enrichedItem.cropGroupName === "" || enrichedItem.cropGroupName === null)) {
                        // Try cropGroupCode first, then cropCategoryCode as fallback
                        const cropGroupCodeToMatch = enrichedItem.cropGroupCode || enrichedItem.cropCategoryCode;
                        if (cropGroupCodeToMatch) {
                            const cropGroupCodeStr = cropGroupCodeToMatch.toString();
                            const matchedCropGroup = cropGroup.find(
                                (cg) => {
                                    if (!cg || !cg.cropGroupCode) return false;
                                    return cg.cropGroupCode.toString() === cropGroupCodeStr;
                                }
                            );
                            if (matchedCropGroup && matchedCropGroup.cropGroupName) {
                                enrichedItem.cropGroupName = matchedCropGroup.cropGroupName;
                                // Also set cropGroupCode if it was missing
                                if (!enrichedItem.cropGroupCode && enrichedItem.cropCategoryCode) {
                                    enrichedItem.cropGroupCode = enrichedItem.cropCategoryCode;
                                }
                                console.log(`Mapped cropGroupCode ${cropGroupCodeToMatch} to ${matchedCropGroup.cropGroupName}`);
                            } else {
                                console.log(`Could not find cropGroup for code: ${cropGroupCodeToMatch}`);
                            }
                        }
                    }

                    // Map cropNameCode to cropName if not already present or empty
                    if ((!enrichedItem.cropName || enrichedItem.cropName === "" || enrichedItem.cropName === null) && enrichedItem.cropNameCode) {
                        const cropNameCodeStr = enrichedItem.cropNameCode.toString();
                        // First try to find in the main cropName array
                        const matchedCropName = cropName.find(
                            (cn) => {
                                if (!cn || !cn.cropNameCode) return false;
                                return cn.cropNameCode.toString() === cropNameCodeStr;
                            }
                        );
                        if (matchedCropName && matchedCropName.cropName) {
                            enrichedItem.cropName = matchedCropName.cropName;
                            console.log(`Mapped cropNameCode ${enrichedItem.cropNameCode} to ${matchedCropName.cropName}`);
                        } else {
                            console.log(`Could not find cropName for code: ${enrichedItem.cropNameCode}`);
                        }
                    }

                    // Map season code to season name if seasonName is a code or empty
                    if ((!enrichedItem.seasonName || enrichedItem.seasonName === "" || enrichedItem.seasonName === null || !isNaN(enrichedItem.seasonName)) && (enrichedItem.seasonCode || enrichedItem.seasons)) {
                        const seasonCodeToMatch = enrichedItem.seasonCode || enrichedItem.seasons;
                        if (seasonCodeToMatch) {
                            const seasonCodeStr = seasonCodeToMatch.toString();
                            const matchedSeason = cropSeason.find(
                                (cs) => {
                                    if (!cs) return false;
                                    // Try matching by seasonCode or id
                                    const csCode = cs.seasonCode ? cs.seasonCode.toString() : (cs.id ? cs.id.toString() : null);
                                    return csCode === seasonCodeStr;
                                }
                            );
                            if (matchedSeason && matchedSeason.seasonName) {
                                enrichedItem.seasonName = matchedSeason.seasonName;
                                console.log(`Mapped seasonCode ${seasonCodeToMatch} to ${matchedSeason.seasonName}`);
                            } else {
                                console.log(`Could not find season for code: ${seasonCodeToMatch}`);
                            }
                        }
                    }

                    return enrichedItem;
                });

                console.log('Enriched data:', enrichedData);
                console.log('Enriched data count:', enrichedData.length);
                console.log('Original data count:', result.dataContent.length);
                // Set the enriched data
                setAssignTargetListing(enrichedData);
            } else {
                setAssignTargetListing([]);
                setMissionTargetSummary([]);
                setGroupedSchemeData([]);
            }
            const dataList = result.dataContent && Array.isArray(result.dataContent) ? result.dataContent : [];
            if (sessionStorage.getItem("userTypeCodeModel") === "2") {
                setAssignTarget(dataList[0]?.centralMission);
                setCropGroup(dataList[0]?.cropGroupName);
                setCropName(dataList[0]?.cropName);
                setMissionTargetSummary(dataList.filter(
                    item => Number(item.centralMission) !== 0
                ));

                // Group by schemeSubTypeName and count districtMission
                const groupedCounts = dataList
                    .filter(item => Number(item.districtMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalDistrictMission += Number(item.districtMission);
                        return groups;
                    }, {});
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);

            }
            if (sessionStorage.getItem("userTypeCodeModel") === "3") {
                setMissionTargetSummary(dataList.filter(
                    item => Number(item.districtMission) !== 0
                ));

                setAssignTargetListing(dataList.filter(
                    item => Number(item.districtCode) === Number(sessionStorage.getItem("districtCodeModel"))
                ));

                const groupedCounts = dataList
                    .filter(item => Number(item.subDistrictMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalsubDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalsubDistrictMission += Number(item.subDistrictMission);
                        return groups;
                    }, {});
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);

            } if (sessionStorage.getItem("userTypeCodeModel") === "4") {
                setAssignSubDistrictTarget(dataList[0]?.villageMission);
                setMissionTargetSummary(dataList.filter(
                    item => Number(item.villageMission) === 0
                ));
                setAssignTargetListing(dataList.filter(
                    item => Number(item.villageMission) !== 0
                ));
                const groupedCounts = dataList
                    .filter(item => Number(item.villageMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalvillageMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalvillageMission += Number(item.villageMission);
                        return groups;
                    }, {});
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);

            }

            setRevisedByState(result.dataContent?.[0]?.isRevisedByState);
            setRevisedTargetByState(result.dataContent?.[0]?.revisedTargetByState);
            // Check conditions for showing modal
            if (
                sessionStorage.getItem("userTypeCodeModel") === "2" &&
                (result.dataContent?.[0]?.isRevisedByState === null || result.dataContent?.[0]?.isRevisedByState?.trim() === "" || (result.dataContent?.[0]?.isRevisedByState?.trim() === "Y" && result.dataContent?.[0]?.revisedTargetByState === null && result.dataContent?.[0]?.revisedTargetByState <= 0))
            ) {

                //setShowModal(true);
            }

        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        } finally {
            setIsTableLoading(false);
        }
    };


    function getStates() {
        const fetchStates = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }


    function getDistrict() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            stateCode: Number(sessionStorage.getItem("stateNameModel")),
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setDistrictData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));

    }
    const handleVillage = () => {
        //console.log('handleVillage called');

        var stateCode = sessionStorage.getItem("stateNameModel");
        var districtCode = sessionStorage.getItem("districtCodeModel");
        var subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        if ((stateCode !== null && stateCode !== "0") && (districtCode !== null && districtCode !== "0") && (subDistrictCode !== null && subDistrictCode !== "0")) {

            var raw = JSON.stringify({
                stateCode,
                districtCode,
                subDistrictCode

            });
            // console.log('raw: ', raw);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent;
                    //console.log('localFormDataVillage: ', localFormDataVillage);
                    let myArrayVillage = [];
                    localFormDataVillage.map((item, key) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));

        }

        //console.log('optionVillage: ',optionVillage);

    }
    const resolveRowData = (survey) => {
        let completeValue = 0;
        let missionValue = 0;
        if (userType === "1") {
            const report = assignTargetReportsSurvey.find(s =>
                Number(s.stateCode) === Number(survey.stateCode) &&
                Number(s.componentId) === Number(survey.subTypeCode) &&
                Number(s.cropGroupCode) === Number(survey.cropCategoryCode) &&
                Number(s.cropNameCode) === Number(survey.cropNameCode) &&
                Number(s.seasonCode) === Number(survey.seasons) &&
                String(s.uomType) === String(survey.uomType)
            );
            completeValue = report ? (report.totalSurveyArea || 0) : 0;
            missionValue = survey.centralMission;
        } else if (userType === "2") {
            const report = assignTargetReports.find(r => {
                const sm = String(r.stateCode || '') === String(survey.stateCode || '');
                const dm = String(r.districtCode || '') === String(survey.districtCode || '');
                if (!sm || !dm) return false;
                const rt = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                const st = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';
                const cgCode = survey.cropCategoryCode || survey.cropGroupCode;
                const cgm = r.cropGroupCode && cgCode ? String(r.cropGroupCode) === String(cgCode) : true;
                const cnm = r.cropNameCode && survey.cropNameCode ? String(r.cropNameCode) === String(survey.cropNameCode) : true;
                if (rt && rt !== '' && rt !== 'null') return sm && dm && rt === st && cgm && cnm;
                return sm && dm && cgm && cnm;
            });
            completeValue = report ? (report.totalSurvey || 0) : 0;
            missionValue = survey.districtMission;
        } else if (userType === "3") {
            const report = assignTargetReports.find(r => {
                const sm = String(r.stateCode || '') === String(survey.stateCode || '');
                const sdm = String(r.subDistrictCode || '') === String(survey.subDistrictCode || '');
                if (!sm || !sdm) return false;
                const rt = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                const st = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';
                const cgCode = survey.cropCategoryCode || survey.cropGroupCode;
                const cgm = r.cropGroupCode && cgCode ? String(r.cropGroupCode) === String(cgCode) : true;
                const cnm = r.cropNameCode && survey.cropNameCode ? String(r.cropNameCode) === String(survey.cropNameCode) : true;
                if (rt && rt !== '' && rt !== 'null') return sm && sdm && rt === st && cgm && cnm;
                return sm && sdm && cgm && cnm;
            });
            completeValue = report ? (report.totalSurvey || 0) : 0;
            missionValue = survey.subDistrictMission;
        } else if (userType === "4" || userType === "5") {
            const report = assignTargetReports.find(r => {
                const sm = String(r.stateCode || '') === String(survey.stateCode || '');
                const vm = String(r.villageCode || '') === String(survey.villageCode || '');
                if (!sm || !vm) return false;
                const rt = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                const st = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';
                const cgCode = survey.cropCategoryCode || survey.cropGroupCode;
                const cgm = r.cropGroupCode && cgCode ? String(r.cropGroupCode) === String(cgCode) : true;
                const cnm = r.cropNameCode && survey.cropNameCode ? String(r.cropNameCode) === String(survey.cropNameCode) : true;
                if (rt && rt !== '' && rt !== 'null') return sm && vm && rt === st && cgm && cnm;
                return sm && vm && cgm && cnm;
            });
            completeValue = report ? (report.totalSurvey || 0) : 0;
            missionValue = survey.villageMission;
        }
        return { completeValue, missionValue };
    };

    const resolveCropGroupName = (survey) => {
        if ((!survey.cropGroupName || survey.cropGroupName === null) && cropGroup && cropGroup.length > 0) {
            const code = (survey.cropGroupCode || survey.cropCategoryCode || '').toString();
            const match = cropGroup.find(cg => cg && cg.cropGroupCode && cg.cropGroupCode.toString() === code);
            return match ? match.cropGroupName : "";
        }
        return survey.cropGroupName || "";
    };

    const resolveSeasonName = (survey) => {
        if (survey.seasonName && !isNaN(survey.seasonName) && cropSeason && cropSeason.length > 0) {
            const code = survey.seasonName.toString();
            const match = cropSeason.find(cs => {
                const csCode = cs.seasonCode ? cs.seasonCode.toString() : (cs.id ? cs.id.toString() : null);
                return csCode === code;
            });
            return match ? match.seasonName : survey.seasonName;
        }
        if ((!survey.seasonName || survey.seasonName === null) && (survey.seasonCode || survey.seasons) && cropSeason && cropSeason.length > 0) {
            const code = (survey.seasonCode || survey.seasons).toString();
            const match = cropSeason.find(cs => {
                const csCode = cs.seasonCode ? cs.seasonCode.toString() : (cs.id ? cs.id.toString() : null);
                return csCode === code;
            });
            return match ? match.seasonName : (survey.seasonCode || survey.seasons || "");
        }
        return survey.seasonName || "";
    };

    const buildExportColumns = () => {
        const cols = ["Sr. No."];
        if (userType === "1") cols.push("State");
        if (userType === "2") { cols.push("District"); cols.push("Type"); }
        if (userType === "3") { cols.push("Sub District"); cols.push("Type"); }
        if (userType === "4" || userType === "5") { cols.push("Village Name"); cols.push("Type"); }
        cols.push("Crop Group", "Crop Name", "Season");
        if (userType === "1") cols.push("Scheme Type");
        cols.push("Physical Target", "Physical Achievement", "Target Achieved", "Target Achieved %");
        return cols;
    };

    const buildExportRows = () => {
        let sr = 1;
        return filteredListing
            .filter(survey => {
                if (userType === "1") return true;
                if (userType === "2" || userType === "3") return !!survey.districtName?.trim();
                return true;
            })
            .map(survey => {
                const { completeValue, missionValue } = resolveRowData(survey);
                const meta = getAchievementMeta(missionValue, completeValue);
                const row = [sr++];
                if (userType === "1") row.push(survey.stateName || "");
                if (userType === "2") { row.push(survey.districtName || ""); row.push(survey.schemeSubTypeName || ""); }
                if (userType === "3") { row.push(survey.subDistrictName || ""); row.push(survey.schemeSubTypeName || ""); }
                if (userType === "4" || userType === "5") { row.push(survey.villageName || ""); row.push(survey.schemeSubTypeName || ""); }
                row.push(resolveCropGroupName(survey), survey.cropName || "", resolveSeasonName(survey));
                if (userType === "1") row.push(survey.schemeSubTypeName || "");
                row.push(
                    `${missionValue} ${survey.uomType || ""}`.trim(),
                    `0 ${survey.uomType || ""}`.trim(),
                    `${completeValue} ${survey.uomType || ""}`.trim(),
                    `${meta.percent}%`
                );
                return row;
            });
    };

    const exportTargetListToCSV = () => {
        if (!filteredListing || filteredListing.length === 0) {
            alert("No data available to export.");
            return;
        }
        const today = new Date();
        const dateStr = today.toISOString().split("T")[0];
        const timeStr = today.toTimeString().split(" ")[0];
        const csvRows = [];
        csvRows.push(["Report", "Target Monitoring"].join(","));
        if (currentSchemeName) csvRows.push(["Scheme", `"${currentSchemeName}"`].join(","));
        if (currentStateName) csvRows.push(["State", `"${currentStateName}"`].join(","));
        if (currentDistrictName) csvRows.push(["District", `"${currentDistrictName}"`].join(","));
        csvRows.push(["Financial Year", `"${finYear}"`].join(","));
        csvRows.push(["Generated At", `"${dateStr} ${timeStr}"`].join(","));
        csvRows.push("");
        csvRows.push(buildExportColumns().map(c => `"${c}"`).join(","));
        buildExportRows().forEach(row => {
            csvRows.push(row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","));
        });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `TargetMonitoring_${dateStr}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportTargetListToPDF = () => {
        if (!filteredListing || filteredListing.length === 0) {
            alert("No data available to export.");
            return;
        }
        const doc = new jsPDF("l", "mm", "a4");
        const now = new Date();
        const pageWidth = doc.internal.pageSize.getWidth();
        const formattedDateTime = now.toLocaleString("en-IN", {
            day: "2-digit", month: "short", year: "numeric",
            hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true
        });
        const logoWidth = 25;
        const logoHeight = 25;
        doc.addImage(kmLogo, "PNG", (pageWidth - logoWidth) / 2, 8, logoWidth, logoHeight);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Krishi MApper", pageWidth / 2, 40, { align: "center" });
        doc.setFontSize(12);
        doc.text("Target Monitoring", pageWidth / 2, 48, { align: "center" });
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        const metaInfo = [];
        if (currentSchemeName) metaInfo.push(`Scheme: ${currentSchemeName}`);
        if (currentStateName) metaInfo.push(`State: ${currentStateName}`);
        if (currentDistrictName) metaInfo.push(`District: ${currentDistrictName}`);
        metaInfo.push(`Financial Year: ${finYear}`);
        doc.text(metaInfo.join("   |   "), pageWidth / 2, 55, { align: "center" });
        doc.text(`Generated on: ${formattedDateTime}`, pageWidth / 2, 61, { align: "center" });
        autoTable(doc, {
            head: [buildExportColumns()],
            body: buildExportRows(),
            startY: 66,
            theme: "grid",
            styles: { fontSize: 8, halign: "center", valign: "middle" },
            headStyles: { fillColor: [46, 125, 50], textColor: [255, 255, 255], fontStyle: "bold" },
            alternateRowStyles: { fillColor: [240, 248, 240] }
        });
        doc.save(`TargetMonitoring_${now.toISOString().split("T")[0]}.pdf`);
    };

    const getAchievementMeta = (missionValue, completeValue) => {
        const missionTarget = Number(missionValue || 0);
        const achieved = Number(completeValue || 0);

        if (!missionTarget || missionTarget === 0) {
            return { percent: "0.00", color: "bg-secondary", label: "N/A" };
        }

        // ✅ ACTUAL percentage (no cap at 100)
        const percent = (achieved / missionTarget) * 100;

        let color = "bg-danger";
        let label = "Poor";

        if (percent > 25 && percent <= 50) {
            color = "bg-warning";
            label = "Better";
        } else if (percent > 50 && percent <= 75) {
            color = "bg-info";
            label = "Average";
        } else if (percent > 75 && percent <= 100) {
            color = "bg-success";
            label = "Excellent";
        } else if (percent > 100) {
            color = "bg-primary";       // 🔥 over-achievement
            label = "Excess";
        }

        return {
            percent: percent.toFixed(2), // e.g. 900.14%
            color,
            label
        };
    };

    const handleSubDistrict = (value) => {
        const districtCode = sessionStorage.getItem("districtCodeModel")

        if (districtCode === null) {
            setDistrictValue(districtCode);
        } else {

            setDistrictValue(value);
        }



        if (districtCode === "NA") return;

        const raw = JSON.stringify({
            districtcode: districtCode,
        });

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => setSubDistrictData(result.dataContent))
            .catch((error) => console.log("Error fetching sub-districts:", error));
    };
    const handleSubmit = async (status) => {
        //alert(status);
        //console.log('status 111', status);
        // Validation for the main row
        if (status === 0) {
            // Validate state selection
            if (stateValue === "NA" || !stateValue) {
                alert("Please select a State before assigning the target.");
                return; // Stop further processing
            }
            if (!assignTarget || isNaN(assignTarget) || Number(assignTarget) <= 0) {
                //toast.error("Please enter a valid Assign Target for the first row");
                alert("Please enter a valid Assign Target first");
                return;
            }
            if (selectedValue === "NA" || !selectedValue) {
                alert("Please select a Type before assigning the target.");
                return; // Stop further processing
            }
            //if (selectedValue === 'Other' && (!txtlType || txtlType.trim() === "")) {
            //    alert(`Please enter a value for 'Enter Type' at first row`);
            //    return;
            //}

        }

        let isValid = true;

        if (!isValid) return;

        if (status === 4) {
            //console.log('333333333333333333');
            // Get the currently selected type data
            //console.log('missionTargetSummary in 4 s', missionTargetSummary);
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName == selectedValue
            );

            // console.log('selectedItem 4s ', selectedItem);
            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Sub District Dropdown
            const subDistrictValue = rowValues[0]?.subDistrictValue;
            if (!subDistrictValue || subDistrictValue === "") {
                alert("Please select a Sub District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            //console.log('groupedSchemeData:', groupedSchemeData);
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName == selectedValue);
            //console.log('existingAssignTargets:', existingAssignTargets);
            //console.log('existingAssignTargets-totalDistrictMission: ', existingAssignTargets[0]?.totalDistrictMission);

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalsubDistrictMission)
                ? 0
                : existingAssignTargets[0].totalsubDistrictMission;

            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            // 4. Validation logic based on Assign By State
            // Get the original data from missionTargetSummary to get Assign By State
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignByState = Number(originalData?.districtMission || 0); // This is the Assign By State value

            // Validate against Assign By State
            if (totalAssignTargetForScheme > assignByState) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By State (${assignByState}). Current input: ${currentAssignTarget}.`);
                //alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By State (${assignByState}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }


            // Create payload based on selected type
            const payload = [{
                finYear,
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: rowValues[0]?.subDistrictValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userTypeCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode,
                cropCategoryCode: selectedItem.cropCategoryCode,
                cropNameCode: selectedItem.cropNameCode,
                uomType: uom
            }];
            //console.log('payload status 4', payload);
            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            subDistrictValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By State
                    setSelectedValue('');
                    setSelectedTypeData({
                        districtName: '',
                        districtMission: ''
                    });

                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 3) {
            //console.log('missionTargetSummary: ', missionTargetSummary);
            //console.log('selectedValue: ', selectedValue);
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => String(item.subTypeCode) === String(selectedValue)
            );
            //console.log('selectedItem status 3', selectedItem);
            //if (!selectedItem) {
            //    alert("Please select a Type first.");
            //    return;
            //}

            if (selectedValue === "NA" || !selectedValue) {
                alert("Please select a Type before assigning the target.");
                return; // Stop further processing
            }

            const assignTargetValue = inputValues[0]?.assignDistrictTarget;

            // 1. Validate the District Dropdown
            const districtValue = inputValues[0]?.districtValue;
            if (!districtValue || districtValue === "NA") {
                alert("Please select a District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate that Assign Target is not greater than the available target
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalDistrictMission)
                ? 0
                : existingAssignTargets[0].totalDistrictMission;

            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            //console.log('totalAssignTargetForScheme :', totalAssignTargetForScheme);

            // 4. CORRECTED Validation logic based on Target Revised By State
            // Get the original data from missionTargetSummary to get correct Target Revised By State
            //console.log('selectedValue b', selectedValue);

            //const selectedItem = missionTargetSummary.find(
            //    item => item.subTypeCode === selectedValue
            //);

            //const originalData = missionTargetSummary.find(item => item.subTypeCode === selectedValue);
            //console.log('originalData: ', originalData);
            const targetRevisedByState = Number(selectedItem?.revisedTargetByState || 0); // This is the actual Target Revised By State
            // console.log('targetRevisedByState: ', targetRevisedByState);
            const assignByCentral = Number(selectedItem?.centralMission || 0); // This is the actual Assign By Central
            //console.log('assignByCentral: ', assignByCentral);
            let availableTarget;
            let alertMessage;

            if (targetRevisedByState === 0) {
                // If Target Revised By State is 0, validate against Assign By Central
                availableTarget = assignByCentral;
                alertMessage = `Total Assign Target for ${selectedItem.schemeSubTypeName} (${totalAssignTargetForScheme}) cannot exceed the Assign By Central (${availableTarget}). Current input: ${currentAssignTarget}`;
                //alertMessage = `Total Assign Target for ${selectedItem.schemeSubTypeName} (${totalAssignTargetForScheme}) cannot exceed the Assign By Central (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            } else {
                // If Target Revised By State > 0, validate against Target Revised By State
                availableTarget = targetRevisedByState;
                alertMessage = `Total Assign Target for ${selectedItem.schemeSubTypeName} (${totalAssignTargetForScheme}) cannot exceed the Target Revised By State (${availableTarget}). Current input: ${currentAssignTarget}`;
                //alertMessage = `Total Assign Target for ${selectedItem.schemeSubTypeName} (${totalAssignTargetForScheme}) cannot exceed the Target Revised By State (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            }

            if (totalAssignTargetForScheme > availableTarget) {
                alert(alertMessage);
                return; // Stop the entire function
            }


            // Create payload based on selected type
            const payload = [{
                finYear,
                schemeCode: sessionStorage.getItem("schemeCodeModel"),
                stateCode: selectedItem.stateCode,
                districtCode: inputValues[0]?.districtValue || "",
                userTypeCode: sessionStorage.getItem("userTypeCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: inputValues[0]?.assignDistrictTarget || "",
                subTypeCode: selectedItem.subTypeCode,
                cropCategoryCode: selectedItem.cropCategoryCode,
                cropNameCode: selectedItem.cropNameCode,
                uomType: uom
            }];

            // console.log('payload status 3 ', payload)

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);
                    setAssignTarget("");
                    setSelectedValue('');
                    setRows([]);
                    //setShowModal(false);
                    setInputValues(prev => ({
                        ...prev,
                        [0]: {
                            ...prev[0],
                            districtValue: "",
                            assignDistrictTarget: ""
                        }
                    }));
                    // Reset Type to "Choose" and clear Assign By Central
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 5) {
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Village Dropdown
            const villageValue = rowValues[0]?.villageValue;
            if (!villageValue || villageValue === "") {
                alert("Please select a Village.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            //// 3. Validate that Assign Target is not greater than the available target
            //const assignTarget = Number(assignTargetValue);
            //const subDistrictMission = Number(selectedItem.subDistrictMission);

            //if (assignTarget > subDistrictMission) {
            //    alert(`The Assign Target (${assignTarget}) cannot be greater than the Assign By Sub District (${subDistrictMission}).`);
            //    return; // Stop the entire function
            //}

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            // const PreviousSubSchemCount = existingAssignTargets[0]?.totalvillageMission;

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalvillageMission)
                ? 0
                : existingAssignTargets[0].totalvillageMission;
            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            //console.log('totalAssignTargetForScheme: ', totalAssignTargetForScheme);

            // 4. Validation logic based on Assign By Sub District
            // Get the original data from missionTargetSummary to get Assign By Sub District
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignBySubDistrict = Number(originalData?.subDistrictMission || 0); // This is the Assign By Sub District value

            // Validate against Assign By Sub District
            if (totalAssignTargetForScheme > assignBySubDistrict) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By Sub District (${assignBySubDistrict}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }

            // Create payload based on selected type
            const payload = [{
                finYear,
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: selectedItem.subDistrictCode,
                villageCode: rowValues[0]?.villageValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userTypeCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode,
                uomType: uom
            }];
            //console.log('payload at v: ', payload);
            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            villageValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By Sub District
                    setSelectedValue('');
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else {
            //console.log('11111');
            // --- Create an array for all targets ---
            const targets = [];
            const isRevisedChar = isStateRevised ? 'Y' : 'N';

            // 1. Add the main/fixed row
            const mainRowTarget = {
                finYear,
                schemeCode: sessionStorage.getItem("schemeCodeModel"),
                stateCode: sessionStorage.getItem("userTypeCodeModel") === "1" ? stateValue : sessionStorage.getItem("stateNameModel"),
                //districtCode: districtValue === 'null' ? '0' : districtValue,
                districtCode: districtValue === '' ? '0' : districtValue,
                subDistrictCode: subDistrictValues || 0,
                villageCode: villageCode || 0,
                userTypeCode: sessionStorage.getItem("userTypeCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: assignTarget,
                subTypeName: selectedValue === 'Other' ? txtlType : null,
                subTypeCode: selectedValue === 'Other' ? -1 : selectedValue,
                IsRevisedByState: isRevisedChar,
                CropCategoryCode: selectedCropGroup,
                CropNameCode: selectedCropName,
                seasons: String(selectedCropSeason || ""),

                uomType: uom
            };
            targets.push(mainRowTarget);


            // If status === 2, use missionTargetSummary with revisedTarget values as payload
            let payloadToSend = targets;
            if (status === 2 && Array.isArray(missionTargetSummary) && missionTargetSummary.length > 0) {
                payloadToSend = missionTargetSummary.map((item, idx) => ({
                    ...item,
                    finYear: finYear,
                    userTypeCode: sessionStorage.getItem("userTypeCodeModel"),
                    createdBy: sessionStorage.getItem("userCodeModel"),
                    subTypeCode: item.subTypeCode,
                    IsRevisedByState: "Y",
                    RevisedTargetByState: inputValues[idx]?.revisedTargetByState || '',
                    // RevisedTargetByState: inputValues[idx] || '',
                    missionTarget: item.centralMission // Use centralMission for each item
                }));
                //console.log('POST payload (missionTargetSummary with revised fields):', payloadToSend);
            } else {
                // console.log('POST payload (default targets):', payloadToSend);
            }

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,// Manvendra
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payloadToSend), // Send the array
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData(); // Refresh
                    toast.success(result.message);
                    // Clear fields
                    setAssignTarget("");
                    setStateValue("NA");
                    setSelectedValue('');
                    setRows([]);
                    //setShowModal(false);
                } else {
                    toast.error("Failed to assign target else: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
    };

    //const handleClear = () => {
    //    //console.log('handleClear');
    //    setAssignTarget("");
    //    setSelectedValue("");
    //    setTxtlType(""); // Also clear the 'Other' text field
    //    setStateValue("NA");
    //    // Remove all dynamically added rows
    //    setRows([]);
    //};

    const handleClear = () => {
        setSelectedValue('');
        setStateValue("NA");           // reset State select to Choose...
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });
        setSelectedCropGroup("NA");    // reset Crop Group to Choose...
        setSelectedCropName("NA");     // reset Crop Name to Choose...
        setAssignTarget("");           // reset Assign Target
        //setInputValues(prev => ({
        //    ...prev,
        //    [0]: {
        //        ...prev[0],
        //        districtValue: "",
        //        assignDistrictTarget: ""
        //    }
        //}));
    };


    return (

        <>
            <ToastContainer autoClose={7000} />

            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Assign Target</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">Assign Target</li>
                        </ol>
                    </nav>
                </div>
                <div>
                    <div className="row mb-4">
                        <div className="col-md-2 finacildd_label">
                            <div className="form-group text-white">
                                <label htmlFor="finYear" className="form-label text-white">Financial Year</label>
                                <select
                                    id="finYear"
                                    name="finYear"
                                    className="form-select"
                                    value={finYear}
                                    onChange={handleFinYearChange}
                                >
                                    <option value="2026-2027">2026-2027</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2024-2025">2024-2025</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="section dashboard asigntarget">
                    <div className="row surveydetailsBg">
                        {userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (
                            <>
                                <div className="col-md-2">
                                    <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>
                                    <input
                                        type="text"
                                        id="finYear"
                                        className="form-control"
                                        name="finYear"
                                        value={finYear}
                                        readOnly
                                    />
                                </div>

                            </>
                        )}
                        {userType !== "1" && userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (

                            <div className="col-md-2">
                                <label htmlFor="schemeName" className="form-label assignlbl">State</label>
                                <input
                                    type="text"
                                    id="schemeName"
                                    className="form-control"
                                    name="schemeName"
                                    value={currentStateName}
                                    readOnly
                                />
                            </div>
                        )}

                        {userType === "4" && (
                            <>
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Sub District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign By Sub District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Village</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                    </div>
                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        revisedTargetByState: '',
                                                        centralMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            revisedTargetByState: selectedItem.revisedTargetByState || '',
                                                            centralMission: selectedItem.subDistrictMission || '' // Use subDistrictMission for sub-district level
                                                        });
                                                    }
                                                }
                                                handleVillage();
                                                // Reset village select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        villageValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue)?.subDistrictName || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeData.centralMission || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        villageValue: e.target.value
                                                    }))
                                                )
                                            }
                                            value={rowValues[0]?.villageValue || ""}
                                        >
                                            <option value="">Choose...</option>
                                            {optionVillage && optionVillage.map((villageItem, villageIdx) => (
                                                <option key={villageIdx} value={villageItem.value}>
                                                    {villageItem.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={rowValues[0]?.targetValue || ""}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        targetValue: e.target.value
                                                    }))
                                                )
                                            }
                                            placeholder="Enter target"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {userType === "3333" && (
                            <>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Financial Year</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Type</label>
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                //console.log('e.target.value:', e.target.value);
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        districtName: '',
                                                        districtMission: ''
                                                    });
                                                } else {
                                                    handleSubDistrict();
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            districtName: selectedItem.districtName || '',
                                                            districtMission: selectedItem.districtMission || ''
                                                        });
                                                    }
                                                }

                                                // Reset sub district select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        subDistrictValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="NA">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {/*<div className="col-md-2">*/}
                                    {/*    <input*/}
                                    {/*        type="text"*/}
                                    {/*        className="form-control"*/}
                                    {/*        value={selectedTypeData.districtName || ''}*/}
                                    {/*        readOnly*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Assign By District</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeObj?.districtMission || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Sub District</label>
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        subDistrictValue: e.target.value
                                                    }))
                                                )
                                            }
                                            value={rowValues[0]?.subDistrictValue || ""}
                                        >
                                            <option value="">Choose...</option>
                                            {subDistrictData && subDistrictData.map((subItem, subIdx) => (
                                                <option key={subIdx} value={subItem.subDistrictCode}>
                                                    {subItem.subDistrictName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">Crop Group</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="cropGroup"
                                            value={selectedTypeObj?.cropGroupName || ''}

                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">Crop Name</label>
                                        <input
                                            type="text"
                                            id="cropName"
                                            className="form-control"
                                            value={selectedTypeObj?.cropName || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">Crop Season</label>
                                        <input
                                            type="text"
                                            id="cropSeason"
                                            className="form-control"
                                            value={selectedTypeObj?.cropSeason || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={rowValues[0]?.targetValue || ""}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        targetValue: e.target.value
                                                    }))
                                                )
                                            }
                                            placeholder="Enter target"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        {sessionStorage.getItem("userTypeCodeModel") === "2" && (
                            <>
                                {/* Header Row: Only labels Rashmi */}
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Financial Year</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Type</label>
                                        <select
                                            id="ddlType"
                                            className="form-control"
                                            onChange={(e) => handleSubTypeSelect(e.target.value)}
                                            value={selectedValue}
                                        >
                                            <option defaultValue value="NA">Choose...</option>
                                            {assignTargetListing
                                                .filter((option, index, self) =>
                                                    index === self.findIndex(item => item.subTypeCode === option.subTypeCode)
                                                )
                                                .map(option => (
                                                    <option key={option.subTypeCode} value={option.subTypeCode}>
                                                        {option.schemeSubTypeName}
                                                    </option>
                                                ))}
                                            {/*<option defaultValue value="NA">Choose...</option>*/}
                                            {/*{assignTargetListing.map(option => (*/}
                                            {/*    <option key={option.subTypeCode} value={option.subTypeCode}>*/}
                                            {/*        {option.schemeSubTypeName}*/}
                                            {/*    </option>*/}
                                            {/*))}*/}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Target Revised By State</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeObj?.revisedTargetByState || 0}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label assignlbl">Assign By Central</label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeObj?.centralMission || 0}
                                            readOnly
                                        />


                                    </div>


                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">District</label>

                                        <select
                                            className="form-select"
                                            disabled={!selectedValue || selectedValue === "NA"}
                                            onFocus={getDistrict}
                                            onChange={e =>
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: e.target.value
                                                    }
                                                }))
                                            }
                                            value={inputValues[0]?.districtValue || ""}
                                        >
                                            <option defaultValue value="NA">Choose...</option>
                                            {districtData && districtData.map((dItem, dIdx) => (
                                                <option key={dIdx} value={dItem.districtCode}>
                                                    {dItem.districtName}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <label className="form-label assignlbl">Crop Group</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="cropGroup"
                                            value={selectedTypeObj?.cropGroupName || ''}

                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2 mt-2">
                                        <label className="form-label assignlbl">Crop Name</label>
                                        <input
                                            type="text"
                                            id="cropName"
                                            className="form-control"
                                            value={selectedTypeObj?.cropName || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2 mt-2">
                                        <label className="form-label assignlbl">Assign Target</label>

                                        <input
                                            type="number"
                                            min="0"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={inputValues[0]?.assignDistrictTarget || ""}
                                            placeholder="0.00"
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setInputValues((prev) => ({
                                                        ...prev,
                                                        [0]: {
                                                            ...prev[0],
                                                            assignDistrictTarget: val,
                                                        },
                                                    }));
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="uom" className="form-label assignlbl">UOM</label>
                                        <select
                                            id="uom"
                                            name="uom"
                                            className="form-select"
                                            value={uom}
                                            onChange={(e) => setUom(e.target.value)}
                                        >
                                            <option value="">Choose...</option>
                                            <option value="Nos">Nos</option>
                                            <option value="Area(ha)">Area (ha)</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        {sessionStorage.getItem("userTypeCodeModel") === "1" && (
                            <>
                                <div className="col-md-2">
                                    <label htmlFor="state" className="form-label assignlbl">State</label>
                                    <select
                                        id="state"
                                        className="form-select"
                                        value={stateValue}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setStateValue(val);

                                            // Rebind Type to Choose... when State is Choose...
                                            if (!val || val === "NA") {
                                                setSelectedValue("NA");
                                                // Optionally also clear dependent selections
                                                setSelectedCropGroup("");
                                                setSelectedCropName("");
                                                setAssignTarget("");
                                            }
                                        }}
                                        onClick={getStates}
                                    >
                                        <option value="NA">Choose...</option>
                                        {statesData.map((item, idx) => (
                                            <option key={idx} value={item.stateCode}>
                                                {item.stateName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="ddlType" className="form-label assignlbl">
                                        Type
                                    </label>
                                    <select
                                        id="ddlType"
                                        className="form-control"
                                        //onChange={(e) => handleSubTypeSelect(e.target.value)}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            handleSubTypeSelect(val);
                                            if (!val || val === "NA") {
                                                setSelectedCropGroup("");
                                                setSelectedCropName("");
                                                setAssignTarget("");
                                            }
                                        }}
                                        value={selectedValue}
                                        disabled={!stateValue || stateValue === "NA"}
                                    >
                                        <option defaultValue value="NA">Choose...</option>
                                        {getAvailableOptions('main').map(option => (
                                            <option key={option.id} value={option.id.toString()}>
                                                {option.schemeSubTypeName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="ddlTypeCropGroup" className="form-label assignlbl">
                                        Crop Group
                                    </label>
                                    <select
                                        id="ddlTypeCropGroup"
                                        className="form-control"
                                        onChange={handleCropGroupChange}

                                        value={selectedCropGroup}
                                        disabled={!selectedValue || selectedValue === "NA"}
                                    >
                                        <option defaultValue value="NA">Choose...</option>
                                        {cropGroup.map(option => (
                                            <option key={option.cropGroupCode} value={option.cropGroupCode.toString()}>
                                                {option.cropGroupName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="ddlTypeCropName" className="form-label assignlbl">
                                        Crop Name
                                    </label>
                                    <select
                                        id="ddlTypeCropName"
                                        className="form-control"
                                        value={selectedCropName}
                                        onChange={handleCropName}
                                        disabled={!selectedCropGroup || selectedCropGroup === 0 || selectedCropGroup === "NA"}
                                    >
                                        <option defaultValue value="NA">Choose...</option>
                                        {cropName.map(option => (
                                            <option key={option.cropNameCode} value={option.cropNameCode.toString()}>
                                                {option.cropName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="ddlTypeCropName" className="form-label assignlbl">
                                        Crop Season
                                    </label>
                                    <select
                                        id="ddlTypeCropName"
                                        className="form-control"
                                        value={selectedCropSeason}
                                        onChange={handleCropSeason}
                                        disabled={!selectedCropGroup || selectedCropGroup === 0 || selectedCropGroup === "NA"}
                                    >
                                        <option defaultValue value="NA">Choose...</option>
                                        {cropSeason.map(option => (
                                            <option key={option.seasonCode} value={option.seasonCode.toString()}>
                                                {option.seasonName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="assignTarget" className="form-label assignlbl">
                                        Assign Target (In Hec)
                                    </label>
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        placeholder="0.00"
                                        pattern="^\d+(\.\d{1,2})?$"
                                        id="assignTarget"
                                        className="form-control"
                                        name="assignTarget"
                                        value={assignTarget}
                                        disabled={!selectedCropName || selectedCropName === 0 || selectedCropName === "NA"}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || Number(val) >= 0) setAssignTarget(val);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") e.preventDefault();
                                        }}
                                    />
                                </div>

                                <div className="col-md-2">
                                    <label htmlFor="uom" className="form-label assignlbl">UOM</label>
                                    <select
                                        id="uom"
                                        name="uom"
                                        className="form-select"
                                        value={uom}
                                        onChange={(e) => setUom(e.target.value)}
                                    >
                                        <option value="">Choose...</option>
                                        <option value="Nos">Nos</option>
                                        <option value="Area(ha)">Area (ha)</option>
                                    </select>
                                </div>


                            </>
                        )}


                        {userType === "2" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(3)}>

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClear}>
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "4" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(5)}>

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearVillage}>
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "3333" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(4)}>
                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearSubDistrict}>
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">

                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(0)}>

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleClear}>
                                    Clear
                                </button>
                            </div>
                        )}

                        <div className="col-md-12">
                            <div className="bigbox1 mt-4">
                                <div className="card" style={{ position: 'relative' }}>
                                    {isTableLoading && (
                                        <div style={{
                                            position: 'absolute',
                                            inset: 0,
                                            background: 'rgba(255,255,255,0.75)',
                                            zIndex: 10,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: 'inherit',
                                            gap: '10px'
                                        }}>
                                            <div className="spinner-border text-success" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <span style={{ color: '#555', fontWeight: 500, fontSize: '0.95rem' }}>Loading data for {finYear}...</span>
                                        </div>
                                    )}
                                    <div className="">
                                        <div className="d-flex justify-content-end gap-2 p-2">
                                            <button
                                                className="btn btn-sm btn-success"
                                                onClick={exportTargetListToCSV}
                                            >
                                                <i className="bi bi-file-earmark-spreadsheet me-1"></i>
                                                Export List in CSV
                                            </button>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={exportTargetListToPDF}
                                            >
                                                <i className="bi bi-file-earmark-pdf me-1"></i>
                                                Export in PDF
                                            </button>
                                        </div>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    {/* {userType === "1" && <th>Action</th>}*/}
                                                    {userType === "1" && <th>State</th>}
                                                    {userType === "2" && <th>District</th>}
                                                    {userType === "2" && <th>Type</th>}
                                                    {userType === "3" && <th>Sub District</th>}
                                                    {userType === "3" && <th>Type</th>}
                                                    {userType === "4" && <th>Village Name</th>}
                                                    {userType === "4" && <th>Type</th>}
                                                    <th>Crop Group</th>
                                                    <th>Crop Name</th>
                                                    <th>Season</th>
                                                    {userType === "5" && <th>Village Name</th>}
                                                    {userType === "5" && <th>Type</th>}
                                                    {/* {userType === "1" && <th>Permission to Revise by State</th>} */}
                                                    {userType === "1" && <th>Scheme Type</th>}
                                                    <th>Physical Target</th>

                                                    <th>Physical Achievement</th>
                                                    <th >Target Achieved </th>
                                                     <th >Target Achieved % </th>
                                                    {(userType === "1" || userType === "2") && (<th>Action</th>)}


                                                </tr>
                                                <tr>
                                                    <td colSpan={
                                                        userType === "1"
                                                            ? 5
                                                            : userType === "2"
                                                                ? 5
                                                                : userType === "3"
                                                                    ? 4
                                                                    : userType === "4"
                                                                        ? 4
                                                                        : userType === "5"
                                                                            ? 4
                                                                            : 2
                                                    }>
                                                    </td>

                                                    {/* <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="targetdone">Target Achieved</td>
                                                    <td className="targetpanding">Target Achieved %</td>
                                                    <td></td> */}

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {(() => {
                                                    console.log('paginatedListing1111: ', paginatedListing);
                                                    let serialNumber = indexOfFirstRecord + 1;
                                                    return paginatedListing.map((survey, index) => {
                                                        const globalIndex = indexOfFirstRecord + index;
                                                        let completeValue = 0;
                                                        let pendingValue = 0;
                                                        let missionValue = 0;
                                                        if (userType === "1") {
                                                            console.log("assignTargetReportsSurvey----@@", assignTargetReportsSurvey);
                                                            // Match report with survey - similar to PDMC logic
                                                            // Check if reports have scheme type info, if not match by other fields
                                                            const report = assignTargetReportsSurvey.find(s => {
                                                                const isBaseMatch =
                                                                    Number(s.stateCode) === Number(survey.stateCode) &&
                                                                    Number(s.componentId) === Number(survey.subTypeCode) &&
                                                                    Number(s.cropGroupCode) === Number(survey.cropCategoryCode) &&
                                                                    Number(s.cropNameCode) === Number(survey.cropNameCode) &&
                                                                    Number(s.seasonCode) === Number(survey.seasons) &&

                                                                    String(s.uomType) === String(survey.uomType);
                                                                return isBaseMatch;
                                                            });

                                                            completeValue = report ? (report.totalSurveyArea || 0) : 0;
                                                            pendingValue = survey.centralMission - completeValue;
                                                            missionValue = survey.centralMission;
                                                        } else if (userType === "2") {
                                                            // Match report with survey for district level
                                                            const report = assignTargetReports.find(
                                                                r => {
                                                                    // Match by stateCode and districtCode
                                                                    const stateMatch = String(r.stateCode || '') === String(survey.stateCode || '');
                                                                    const districtMatch = String(r.districtCode || '') === String(survey.districtCode || '');
                                                                    if (!stateMatch || !districtMatch) return false;

                                                                    // Check if report has scheme type information
                                                                    const reportType = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                                                                    const surveyType = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';

                                                                    // Match crop group (using cropCategoryCode as fallback)
                                                                    const surveyCropGroupCode = survey.cropCategoryCode || survey.cropGroupCode;
                                                                    const cropGroupMatch = r.cropGroupCode && surveyCropGroupCode
                                                                        ? String(r.cropGroupCode) === String(surveyCropGroupCode)
                                                                        : true;

                                                                    // Match crop name
                                                                    const cropNameMatch = r.cropNameCode && survey.cropNameCode
                                                                        ? String(r.cropNameCode) === String(survey.cropNameCode)
                                                                        : true;

                                                                    // If report has scheme type info, use it for matching
                                                                    if (reportType && reportType !== '' && reportType !== 'null') {
                                                                        const typeMatch = reportType === surveyType;
                                                                        return stateMatch && districtMatch && typeMatch && cropGroupMatch && cropNameMatch;
                                                                    }

                                                                    // If no scheme type in report, match by location + crop data
                                                                    return stateMatch && districtMatch && cropGroupMatch && cropNameMatch;
                                                                }
                                                            );
                                                            completeValue = report ? (report.totalSurvey || 0) : 0;
                                                            pendingValue = survey.districtMission - completeValue;
                                                            missionValue = survey.districtMission;
                                                        } else if (userType === "3") {
                                                            // Match report with survey for sub-district level
                                                            const report = assignTargetReports.find(
                                                                r => {
                                                                    // Match by stateCode and subDistrictCode
                                                                    const stateMatch = String(r.stateCode || '') === String(survey.stateCode || '');
                                                                    const subDistrictMatch = String(r.subDistrictCode || '') === String(survey.subDistrictCode || '');
                                                                    if (!stateMatch || !subDistrictMatch) return false;

                                                                    // Check if report has scheme type information
                                                                    const reportType = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                                                                    const surveyType = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';

                                                                    // Match crop group (using cropCategoryCode as fallback)
                                                                    const surveyCropGroupCode = survey.cropCategoryCode || survey.cropGroupCode;
                                                                    const cropGroupMatch = r.cropGroupCode && surveyCropGroupCode
                                                                        ? String(r.cropGroupCode) === String(surveyCropGroupCode)
                                                                        : true;

                                                                    // Match crop name
                                                                    const cropNameMatch = r.cropNameCode && survey.cropNameCode
                                                                        ? String(r.cropNameCode) === String(survey.cropNameCode)
                                                                        : true;

                                                                    // If report has scheme type info, use it for matching
                                                                    if (reportType && reportType !== '' && reportType !== 'null') {
                                                                        const typeMatch = reportType === surveyType;
                                                                        return stateMatch && subDistrictMatch && typeMatch && cropGroupMatch && cropNameMatch;
                                                                    }

                                                                    // If no scheme type in report, match by location + crop data
                                                                    return stateMatch && subDistrictMatch && cropGroupMatch && cropNameMatch;
                                                                }
                                                            );
                                                            completeValue = report ? (report.totalSurvey || 0) : 0;
                                                            pendingValue = survey.subDistrictMission - completeValue;
                                                            missionValue = survey.subDistrictMission;
                                                        } else if (userType === "4" || userType === "5") {
                                                            // Match report with survey for village level
                                                            const report = assignTargetReports.find(
                                                                r => {
                                                                    // Match by stateCode and villageCode
                                                                    const stateMatch = String(r.stateCode || '') === String(survey.stateCode || '');
                                                                    const villageMatch = String(r.villageCode || '') === String(survey.villageCode || '');
                                                                    if (!stateMatch || !villageMatch) return false;

                                                                    // Check if report has scheme type information
                                                                    const reportType = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                                                                    const surveyType = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';

                                                                    // Match crop group (using cropCategoryCode as fallback)
                                                                    const surveyCropGroupCode = survey.cropCategoryCode || survey.cropGroupCode;
                                                                    const cropGroupMatch = r.cropGroupCode && surveyCropGroupCode
                                                                        ? String(r.cropGroupCode) === String(surveyCropGroupCode)
                                                                        : true;

                                                                    // Match crop name
                                                                    const cropNameMatch = r.cropNameCode && survey.cropNameCode
                                                                        ? String(r.cropNameCode) === String(survey.cropNameCode)
                                                                        : true;

                                                                    // If report has scheme type info, use it for matching
                                                                    if (reportType && reportType !== '' && reportType !== 'null') {
                                                                        const typeMatch = reportType === surveyType;
                                                                        return stateMatch && villageMatch && typeMatch && cropGroupMatch && cropNameMatch;
                                                                    }

                                                                    // If no scheme type in report, match by location + crop data
                                                                    return stateMatch && villageMatch && cropGroupMatch && cropNameMatch;
                                                                }
                                                            );
                                                            completeValue = report ? (report.totalSurvey || 0) : 0;
                                                            pendingValue = survey.villageMission - completeValue;
                                                            missionValue = survey.villageMission;
                                                        }
                                                        const shouldShow =
                                                            userType === "1" ? true : // Always show for userType "1"
                                                                (userType === "3" && survey.subDistrictName == null) ||
                                                                (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
                                                        if (!shouldShow) return null;
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr>
                                                                    <td>{serialNumber++}</td>

                                                                    {userType === "1" && <td>{survey.stateName}</td>}
                                                                    {(userType === "4" || userType === "5") && (
                                                                        <td>{survey.villageName}</td>
                                                                    )}

                                                                    {/* {userType === "1" && (
                                                                                                                   <td>
                                                                                                                       {survey.isRevisedByState?.toLowerCase() === "y" &&
                                                                                                                           survey.revisedTargetByState === null
                                                                                                                           ? "Yes"
                                                                                                                           : "No"}
                                                                                                                   </td>
                                                                                                               )} */}

                                                                    {userType === "2" && <td>{survey.districtName}</td>}
                                                                    {userType === "3" && <td>{survey.subDistrictName}</td>}


                                                                    <td>{(() => {
                                                                        // If cropGroupName is empty but cropGroupCode or cropCategoryCode exists, try to map it
                                                                        if ((!survey.cropGroupName || survey.cropGroupName === "" || survey.cropGroupName === null) && cropGroup && cropGroup.length > 0) {
                                                                            const cropGroupCodeToMatch = survey.cropGroupCode || survey.cropCategoryCode;
                                                                            if (cropGroupCodeToMatch) {
                                                                                const cropGroupCodeStr = cropGroupCodeToMatch.toString();
                                                                                const matchedCropGroup = cropGroup.find(
                                                                                    (cg) => {
                                                                                        if (!cg || !cg.cropGroupCode) return false;
                                                                                        return cg.cropGroupCode.toString() === cropGroupCodeStr;
                                                                                    }
                                                                                );
                                                                                return matchedCropGroup ? matchedCropGroup.cropGroupName : "";
                                                                            }
                                                                        }
                                                                        return survey.cropGroupName || "";
                                                                    })()}</td>
                                                                    <td>{survey.cropName}</td>
                                                                    <td>{(() => {
                                                                        // If seasonName is a numeric code, map it to season name
                                                                        if (survey.seasonName && !isNaN(survey.seasonName) && cropSeason && cropSeason.length > 0) {
                                                                            const seasonCode = survey.seasonName.toString();
                                                                            const matchedSeason = cropSeason.find(
                                                                                (cs) => {
                                                                                    if (!cs) return false;
                                                                                    const csCode = cs.seasonCode ? cs.seasonCode.toString() : (cs.id ? cs.id.toString() : null);
                                                                                    return csCode === seasonCode;
                                                                                }
                                                                            );
                                                                            return matchedSeason ? matchedSeason.seasonName : survey.seasonName;
                                                                        }
                                                                        // If seasonName is empty/null but seasonCode exists, try to map it
                                                                        if ((!survey.seasonName || survey.seasonName === "" || survey.seasonName === null) && (survey.seasonCode || survey.seasons) && cropSeason && cropSeason.length > 0) {
                                                                            const seasonCodeToMatch = (survey.seasonCode || survey.seasons).toString();
                                                                            const matchedSeason = cropSeason.find(
                                                                                (cs) => {
                                                                                    if (!cs) return false;
                                                                                    const csCode = cs.seasonCode ? cs.seasonCode.toString() : (cs.id ? cs.id.toString() : null);
                                                                                    return csCode === seasonCodeToMatch;
                                                                                }
                                                                            );
                                                                            return matchedSeason ? matchedSeason.seasonName : (survey.seasonCode || survey.seasons || "");
                                                                        }
                                                                        return survey.seasonName || "";
                                                                    })()}</td>
                                                                    <td>{survey.schemeSubTypeName}</td>

                                                                    {/* ✅ Mission value column */}
                                                                    <td>
                                                                        {missionValue} {survey.uomType}
                                                                    </td>


                                                                    <td>0 {survey.uomType}</td>

                                                                    <td>{completeValue} {survey.uomType}</td>
                                                                    {/* <td className="fw-semibold text-danger">
                                                                        {(
                                                                            Math.max(
                                                                                Number(missionValue || 0) - Number(completeValue || 0)

                                                                            )
                                                                        ).toFixed(2)} {survey.uomType}
                                                                    </td> */}
                                                                    <td style={{ minWidth: "160px" }}>
                                                                        {(() => {
                                                                            const meta = getAchievementMeta(missionValue,completeValue);

                                                                            return (
                                                                                <>
                                                                                    <div className="d-flex justify-content-between mb-1">
                                                                                        <small className="fw-semibold">{meta.percent}%</small>
                                                                                        <small className="fw-bold">{meta.label}</small>
                                                                                    </div>

                                                                                    <div className="progress" style={{ height: "12px" }}>
                                                                                        <div
                                                                                            className={`progress-bar ${meta.color}`}
                                                                                            role="progressbar"
                                                                                            style={{ width: `${meta.percent}%` }}
                                                                                            aria-valuenow={meta.percent}
                                                                                            aria-valuemin="0"
                                                                                            aria-valuemax="100"
                                                                                        />
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        })()}
                                                                    </td>

                                                                    {(userType === "1" || userType === "2") && (
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => handleEdit(survey)}
                                                                            >
                                                                                ✏️
                                                                            </button>
                                                                        </td>
                                                                    )}

                                                                </tr>
                                                            </React.Fragment>
                                                        );
                                                    });
                                                })()}
                                            </tbody>

                                        </table>
                                        {totalPages > 1 && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="pagination-info">
                                                    Showing {filteredListing.length === 0 ? 0 : indexOfFirstRecord + 1}
                                                    {" "}to {Math.min(indexOfLastRecord, filteredListing.length)} of {filteredListing.length} entries
                                                </div>
                                                <nav aria-label="Page navigation">
                                                    <ul className="pagination mb-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                                                                First
                                                            </button>
                                                        </li>
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}>
                                                                Previous
                                                            </button>
                                                        </li>
                                                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                            let pageNumber;
                                                            if (totalPages <= 5) pageNumber = i + 1;
                                                            else if (currentPage <= 3) pageNumber = i + 1;
                                                            else if (currentPage >= totalPages - 2) pageNumber = totalPages - 4 + i;
                                                            else pageNumber = currentPage - 2 + i;
                                                            return (
                                                                <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                                                                    <button className="page-link" onClick={() => setCurrentPage(pageNumber)}>
                                                                        {pageNumber}
                                                                    </button>
                                                                </li>
                                                            );
                                                        })}
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>
                                                                Next
                                                            </button>
                                                        </li>
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
                                                                Last
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {showModal && sessionStorage.getItem("userTypeCodeModel") === "2" && (
                    <div className="modal fade show d-block edittargrt" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Target Revised By State</h5>

                                </div>
                                <div className="modal-body">
                                    <p>For the <b className="helights"> Financial Year {finYear}, </b>  target of <b className="helights"> {summaryString} surveys </b> under the <b className="helights"> {currentSchemeName}</b> scheme has been assigned to the state of
                                        <b className="helights"> {currentStateName} </b> by the Central Government. You have the option to revise this target and set it as per your preference. However,
                                        If you choose not to revise it, you will have to work with the target
                                        assigned by the Central Government. So, would you like to revise your target?</p>


                                    <div class="col-md-12 d-flex justify-content-md-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-success farmrbtn me-2"
                                            onClick={() => {
                                                setShowTargetInput(true);
                                                setIsYesButtonDisabled(true);
                                            }}
                                            disabled={isYesButtonDisabled}
                                        >
                                            Yes
                                        </button>
                                        <button type="button" className="btn btn-success me-md-2" onClick={() => handleSubmit(1)} >No</button>
                                    </div>


                                    {showTargetInput && (
                                        <div className="col-md-12 mt-3">
                                            {missionTargetSummary && missionTargetSummary.length > 0 ? (
                                                missionTargetSummary.map((item, idx) => (
                                                    <div key={idx} className="row align-items-center mb-2">
                                                        <label className="col-md-4 col-form-label">
                                                            {item.schemeSubTypeName}
                                                        </label>
                                                        <div className="col-md-6">
                                                            <input
                                                                type="text"
                                                                className="form-control targetinput"
                                                                name={`revisedTarget_${idx}`}
                                                                placeholder="000000"
                                                                value={inputValues[idx]?.revisedTargetByState || ''}
                                                                onChange={e => handleChange(idx, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No mission target summary available.</div>
                                            )}
                                            <div className="d-flex justify-content-md-center mt-3">
                                                <button type="button" className="btn btn-success farmrbtn me-2" onClick={() => {
                                                    // Update missionTargetSummary with input values
                                                    const updated = missionTargetSummary.map((item, idx) => ({
                                                        ...item,
                                                        revisedTarget: inputValues[idx] || ''
                                                    }));

                                                    handleSubmit(2);
                                                }}>
                                                    Revise Target
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </div>
                )}

                {/* rupali */}
                {showModals && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header bg-success">
                                    <h5 className="modal-title">✏️ Update Target</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowModals(false)}
                                    />
                                </div>

                                <div className="modal-body">
                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <label className="form-label">Scheme</label>
                                            <input className="form-control" value={editRow.schemeName} disabled />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Financial Year</label>
                                            <input className="form-control" value={finYear} disabled />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">State</label>
                                            <select
                                                id="state"
                                                className="form-select"
                                                value={stateValue}
                                                onChange={(e) => setStateValue(e.target.value)}
                                                onClick={getStates}
                                            >
                                                <option value="NA">Choose...</option>
                                                {statesData.map((item, idx) => (
                                                    <option key={idx} value={item.stateCode?.toString() || "NA"}>
                                                        {item.stateName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* <div className="col-md-6">
                                            <label className="form-label">District</label>
                                            <input
                                                className="form-control"
                                                value={editRow.districtName || "-"}
                                                disabled
                                            />
                                        </div> */}
                                        <div className="col-md-3">
                                            <label className="form-label">Target</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.missionTarget}
                                                onChange={(e) =>
                                                    setFormData(prev => ({ ...prev, missionTarget: e.target.value }))
                                                }
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">UOM</label>
                                            <select
                                                id="uom"
                                                name="uom"
                                                className="form-select"
                                                value={uom}
                                                onChange={(e) => setUom(e.target.value)}
                                            >
                                                <option value="">Choose...</option>
                                                <option value="Nos">Nos</option>
                                                <option value="Area(ha)">Area (ha)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="ddlType" className="form-label assignlbl">
                                                Type
                                            </label>
                                            <select
                                                id="ddlType"
                                                className="form-select"
                                                onChange={(e) => handleSubTypeSelect(e.target.value)}
                                                value={selectedValue}
                                            >
                                                <option value="NA">Choose...</option>

                                                {getAvailableOptions("main").map((option) => (
                                                    <option key={option.id} value={option.id.toString()}>
                                                        {option.schemeSubTypeName}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label assignlbl">Crop Group</label>
                                            <select
                                                id="ddlType"
                                                className="form-control"
                                                onChange={handleCropGroupChangeInModal}
                                                // onChange={(e) =>
                                                //         setFormData({ ...formData, CropGroup: e.target.value })
                                                //     }
                                                value={selectedCropGroupForModal}
                                            > <option value="NA">Choose...</option>

                                                {cropGroup && cropGroup.length > 0 ? (
                                                    cropGroup.map((option) => (
                                                        <option key={option.cropGroupCode} value={option.cropGroupCode.toString()}>
                                                            {option.cropGroupName}
                                                        </option>
                                                    ))
                                                ) : (
                                                    // Fallback: try to get unique crop groups from ddlSubTypeList if cropGroup is empty
                                                    ddlSubTypeList && ddlSubTypeList.length > 0 ? (
                                                        [...new Map(ddlSubTypeList
                                                            .filter(opt => opt.cropGroupName)
                                                            .map(opt => [opt.cropGroupName, opt]))
                                                            .values()].map((option) => (
                                                                <option key={option.id} value={option.id.toString()}>
                                                                    {option.cropGroupName}
                                                                </option>
                                                            ))
                                                    ) : null
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label assignlbl">Crop Name</label>
                                            <select
                                                id="ddlCropNameModal"
                                                className="form-control"
                                                onChange={handleCropNameChangeInModal}
                                                value={selectedCropNameForModal}
                                                disabled={!selectedCropGroupForModal || selectedCropGroupForModal === "NA"}
                                            > <option value="NA">Choose...</option>

                                                {(cropNameForModal && cropNameForModal.length > 0) ? (
                                                    cropNameForModal.map((option) => (
                                                        <option key={option.cropNameCode} value={option.cropNameCode.toString()}>
                                                            {option.cropName}
                                                        </option>
                                                    ))
                                                ) : (
                                                    // Fallback: use main cropName state if cropNameForModal is empty
                                                    cropName && cropName.length > 0 ? (
                                                        cropName.map((option) => (
                                                            <option key={option.cropNameCode} value={option.cropNameCode.toString()}>
                                                                {option.cropName}
                                                            </option>
                                                        ))
                                                    ) : null
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label assignlbl">Crop Season</label>
                                            <select
                                                id="ddlCropSeasonModal"
                                                className="form-control"
                                                onChange={handleCropSeasonChangeInModal}
                                                value={selectedCropSeasonForModal}
                                            > <option value="NA">Choose...</option>

                                                {cropSeason && cropSeason.length > 0 ? (
                                                    cropSeason.map((option) => (
                                                        <option key={option.seasonCode || option.id} value={(option.seasonCode || option.id).toString()}>
                                                            {option.seasonName}
                                                        </option>
                                                    ))
                                                ) : null}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-bg-danger"
                                        onClick={handleResetEditForm}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-success"
                                        onClick={handleUpdate}
                                    >
                                        Update Target
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
                {/* Rupali */}
            </main>

            <AdminFooterNew />
        </>
    );
}

export default AssignTargetOS;